import React from 'react';
import { fetchUserList as fetchUserListService } from '../../services/userService';
import { User } from '../../state/user';
import AsyncAutoComplete from './AsyncAutoComplete';

type UserComboBoxProps =
  | {
      isMulti: true;
      handleChange: (result: User[]) => void;
      selectedValue: User[];
      isDisabled?: boolean;
      error?: boolean;
      helperText?: string;
      label?: string;
      filterField?: string;
      variant?: 'standard' | 'outlined' | 'filled';
    }
  | {
      isMulti?: false;
      handleChange: (result: User) => void;
      selectedValue: User;
      isDisabled?: boolean;
      error?: boolean;
      helperText?: string;
      label?: string;
      filterField?: string;
      variant?: 'standard' | 'outlined' | 'filled';
    };

const UserComboBox: React.FC<UserComboBoxProps> = (props) => {
  const {
    handleChange,
    selectedValue,
    isDisabled = false,
    isMulti = false,
    error,
    helperText,
    label = 'User',
    filterField = 'FullNameWithUserName.Contains',
    variant = 'standard',
  } = props;

  const userPromiseOptions = async (inputValue: string) => {
    const { data: rows } = await fetchUserListService({
      // filters: { 'FullNameWithUserName.Contains': inputValue },
      filters: { [filterField]: inputValue },
      paging: { pageNumber: 0, pageSize: 10 },
    });

    return rows;
  };

  return (
    <AsyncAutoComplete
      name="User"
      value={selectedValue}
      getOptionValue={(option: User) => {
        return option.id
          ? option.id.toString()
          : [option.fullName, option.company, option.department]
              .filter(Boolean)
              .join('-');
      }}
      getOptionLabel={(option: User) => {
        const userFullName = option.fullName
          ? option.activated
            ? option.fullName
            : `${option.fullName} (Inactive)`
          : '';

        const company = option.company ? ` - ${option.company}` : '';
        const department = option.department ? ` - ${option.department}` : '';
        return userFullName + company + department;
        //return option.fullNameWithUserName ? option.fullNameWithUserName : '';
      }}
      promiseOptions={userPromiseOptions}
      placeholder={'Search by first name'}
      handleChange={handleChange}
      isDisabled={isDisabled}
      isMulti={isMulti}
      error={error}
      helperText={helperText}
      label={label}
      variant={variant}
      inputHeight={38}
    />
  );
};

export default UserComboBox;
